module.exports = __webpack_public_path__ + "img/wip-status.219e96a5.svg";